import {ResetPasswordRepository} from '@domain/model/Account/ResetPassword/ResetPasswordRepository';

const ResetPassword = (repository: ResetPasswordRepository): ((password: string) => Promise<void>) => {
  return (password: string): Promise<void> => {
    return repository.resetPassword(password);
  };
};

export {ResetPassword};
